<div class="red-popup">
    <span class="errorIcon"></span>
    <div class="content">
        <span class="fw-400">{{ message }}</span>
    </div>
</div>
